// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "6363") return "6363.f1d531946.bundle.js";
  // return url for filenames based on template
  return "" + chunkId + ".f1d531946.chunk.js"
}